import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "../data/content";

const QUALITIES = [
  { title: "Personalized", copy: "Every look is tailored to you." },
  { title: "Timeless", copy: "Beauty that photographs beautifully and never feels overdone." },
  { title: "Attentive", copy: "A calm, thoughtful experience from consultation to final touch." },
];

export const About = () => (
  <section id="about" data-testid="section-about" className="py-24 sm:py-36">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-14 md:gap-20 items-center">
      <Reveal className="relative">
        <div className="absolute -inset-4 border border-[#B8893B]/30 rounded-t-[12rem] rounded-b-2xl translate-x-4 translate-y-4" aria-hidden="true" />
        <div className="relative overflow-hidden rounded-t-[12rem] rounded-b-2xl">
          <img
            src={IMAGES.portrait}
            alt="Portrait of Mrinalee, professional makeup artist"
            loading="lazy"
            className="w-full h-[440px] sm:h-[560px] object-cover object-[50%_15%] hover:scale-[1.03] transition-transform duration-[1.4s] ease-out"
          />
        </div>
      </Reveal>

      <div>
        <Reveal>
          <Eyebrow index="01">Meet Mrinalee</Eyebrow>
          <h2 className="font-serif-ed font-normal text-3xl sm:text-4xl lg:text-5xl leading-[1.12] mt-6 text-[#2A1F16]">
            Makeup is more than getting ready —{" "}
            <em className="text-[#96754D]">it's about feeling completely yourself.</em>
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="mt-7 text-sm sm:text-base leading-relaxed text-[#6B5A49] max-w-lg">
            Mrinalee creates refined, personalized makeup looks that enhance natural features while
            reflecting each client's individual personality and occasion — makeup that feels like
            you, on your most memorable days.
          </p>
        </Reveal>
        <div className="mt-10 divide-y divide-[#E9DCC8] border-y border-[#E9DCC8]">
          {QUALITIES.map((q, i) => (
            <Reveal key={q.title} delay={0.1 + i * 0.08}>
              <div className="py-5 flex items-baseline gap-6" data-testid={`about-quality-${q.title.toLowerCase()}`}>
                <span className="text-[11px] uppercase tracking-[0.28em] text-[#2A1F16] font-semibold w-32 shrink-0">
                  {q.title}
                </span>
                <span className="text-[15px] text-[#6B5A49] leading-relaxed">{q.copy}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
